<div class="header-fmarket">
    <div class="logo logo-dark d-flex">
        <a href="">
            <div class="m-t-20">
                <img src="/assets/images/logo/logo-fo.png" alt="">
            </div>
        </a>
    </div>
    <div class="nav-wrap">
        <app-breadcrumb></app-breadcrumb>
    </div>
</div>
<!-- <div class="container-color" style="display: none;">
    <div class="list-color" *ngIf="!isHide">
        <div class="d-flex" (click)="changeTheme('primary')" style="cursor: pointer;">
            <div class="color color-primary mb-2" [class.active-color]="theme === 'primary'"></div>
            <span class="ml-3">Primary </span>
        </div>
        <div class="d-flex" (click)="changeTheme('dark-night')" style="cursor: pointer;">
            <div class="color color-dark-night mb-2" [class.active-color]="theme === 'dark-night'"></div>
            <span class="ml-3">Dark </span>
        </div>
        <div class="d-flex" (click)="changeTheme('default')" style="cursor: pointer;">
            <div class="color color-default mb-2" [class.active-color]="theme === 'default'"></div>
            <span class="ml-3">Default </span>
        </div>
        <div class="d-flex" (click)="changeTheme('dynamic')" style="cursor: pointer;">
            <div class="color color-dynamic mb-2" [class.active-color]="theme === 'dynamic'"></div>
            <span class="ml-3">Dynamic </span>
        </div>

        <div class="sub-dynamic-color d-flex flex-column" *ngIf="theme === 'dynamic'">
            <div class="d-flex">
                <span class="mr-2">Background color: </span>
                <div class="color" [style.background-color]="dynamicColor.color" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color')"
                    [(colorPicker)]="dynamicColor.color"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Text color: </span>
                <div class="color" [style.background-color]="dynamicColor.color1" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color1')"
                    [(colorPicker)]="dynamicColor.color1"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Menu effect: </span>
                <div class="color" [style.background-color]="dynamicColor.color4" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color4')"
                    [(colorPicker)]="dynamicColor.color4"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Table background: </span>
                <div class="color" [style.background-color]="dynamicColor.color5" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color5')"
                    [(colorPicker)]="dynamicColor.color5"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Table body text: </span>
                <div class="color" [style.background-color]="dynamicColor.color2" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color2')"
                    [(colorPicker)]="dynamicColor.color2"></div>
            </div>
        </div>
    </div>
    <div class="btn-container btn-container-right" (click)="hideTheme()" *ngIf="!isHide">
    </div>
    <div class="btn-container btn-container-left" (click)="showTheme()" *ngIf="isHide">
        <span class="ml-1">Theme</span>
    </div>
</div> -->